module.exports = __webpack_public_path__ + "img/IDSLogo.ab6ff3c1.png";